import { Model } from 'src/types'

export const imageBaseUrl = '/gorilla/baseModels'

export const gloveTaxIncludePrice = 80300
export const mittTaxIncludePrice = 82500

const imageWidth = 240
export const gorillaBaseModel: Model[] = [
  {
    productNumber: '001-20',
    position: 'pitcher',
    imageUrl: `${imageBaseUrl}/001-20.jpg`,
    dominantArm: 'both',
    size: 30.0,
    webParts: 'w5',
    description: '',
    series: '',
    isFingerCrotch: false,
    isUBack: false,
    price: gloveTaxIncludePrice,
    bomberPrice: gloveTaxIncludePrice,
    brand: 'gorilla',
    imageWidth,
    imageHeight: 160
  },
  {
    productNumber: 'OBK-20',
    position: 'pitcher',
    imageUrl: `${imageBaseUrl}/obk-20.jpg`,
    dominantArm: 'both',
    size: 28.3,
    webParts: 'w5',
    description: '',
    series: '',
    isFingerCrotch: false,
    isUBack: false,
    price: gloveTaxIncludePrice,
    bomberPrice: gloveTaxIncludePrice,
    brand: 'gorilla',
    imageWidth,
    imageHeight: 160
  },
  {
    productNumber: 'SKR-20',
    position: 'pitcher',
    imageUrl: `${imageBaseUrl}/skr-20.jpg`,
    dominantArm: 'both',
    size: 30.0,
    webParts: 'w5',
    description: '',
    series: '',
    isFingerCrotch: false,
    isUBack: false,
    price: gloveTaxIncludePrice,
    bomberPrice: gloveTaxIncludePrice,
    brand: 'gorilla',
    imageWidth,
    imageHeight: 160
  },
  {
    productNumber: '004',
    position: 'infielder',
    imageUrl: `${imageBaseUrl}/004.jpeg`,
    dominantArm: 'both',
    size: 28.0, // サイズ合っているか
    webParts: 'w11',
    description: '',
    series: '',
    isFingerCrotch: true,
    isUBack: false,
    price: gloveTaxIncludePrice,
    brand: 'gorilla',
    imageWidth,
    imageHeight: 190
  },
  {
    productNumber: '006',
    position: 'infielder',
    imageUrl: `${imageBaseUrl}/006.jpeg`,
    dominantArm: 'both',
    size: 29.6,
    webParts: 'w29',
    description: '',
    series: '',
    isFingerCrotch: true,
    isUBack: false,
    price: gloveTaxIncludePrice,
    brand: 'gorilla',
    imageWidth,
    imageHeight: 200
  },
  {
    productNumber: '00789',
    position: 'outfielder',
    imageUrl: `${imageBaseUrl}/00789.jpeg`,
    dominantArm: 'both',
    size: 31.5, // サイズ
    webParts: 'w19',
    description: '',
    series: '',
    isFingerCrotch: false,
    isUBack: false,
    price: gloveTaxIncludePrice,
    brand: 'gorilla',
    imageWidth,
    imageHeight: 240
  },
  {
    productNumber: 'BKN-20',
    position: 'outfielder',
    imageUrl: `${imageBaseUrl}/bkn-20.jpg`,
    dominantArm: 'both',
    size: 0, // サイズ
    webParts: 'w23',
    description: '',
    series: '',
    isFingerCrotch: true,
    isUBack: false,
    price: gloveTaxIncludePrice,
    brand: 'gorilla',
    imageWidth,
    imageHeight: 185
  },
  {
    productNumber: '003',
    position: 'first',
    imageUrl: `${imageBaseUrl}/003.jpeg`,
    dominantArm: 'both',
    size: 32.5, // サイズ
    webParts: '',
    description: '',
    series: '',
    isFingerCrotch: false,
    isUBack: false,
    price: mittTaxIncludePrice,
    brand: 'gorilla',
    imageWidth,
    imageHeight: 210
  },
  {
    productNumber: '002',
    position: 'catcher',
    imageUrl: `${imageBaseUrl}/002.jpeg`,
    dominantArm: 'both',
    size: 32.5, // サイズ
    webParts: '',
    description: '',
    series: '',
    isFingerCrotch: false,
    isUBack: false,
    backStyle: 'beltBackStyleCatcher',
    price: mittTaxIncludePrice,
    brand: 'gorilla',
    imageWidth,
    imageHeight: 200
  }
]
